export const episodeConstants = {
	EpisodeGetByFilterRequest: "EPISODE_GET_BYFILTER_STARTED",
	EpisodeGetByFilterSuccess: "EPISODE_GET_BYFILTER_COMPLETED",
	EpisodeGetByFilterFailure: "EPISODE_GET_BYFILTER_FAILED",

	EpisodeGetDetailRequest: "EPISODE_GET_DETAIL_STARTED",
	EpisodeGetDetailSuccess: "EPISODE_GET_DETAIL_COMPLETED",
	EpisodeGetDetailFailure: "EPISODE_GET_DETAIL_FAILED",

	EpisodeGetDropdownRequest: "EPISODE_GET_DROPDOWN_STARTED",
	EpisodeGetDropdownSuccess: "EPISODE_GET_DROPDOWN_COMPLETED",
	EpisodeGetDropdownFailure: "EPISODE_GET_DROPDOWN_FAILED",

	EpisodeSaveRequest: "EPISODE_SAVE_STARTED",
	EpisodeSaveSuccess: "EPISODE_SAVE_COMPLETED",
	EpisodeSaveFailure: "EPISODE_SAVE_FAILED",

	EpisodeDeleteRequest: "EPISODE_DELETE_STARTED",
	EpisodeDeleteSuccess: "EPISODE_DELETE_COMPLETED",
	EpisodeDeleteFailure: "EPISODE_DELETE_FAILED",

	EpisodeGetReadingRequest: "EPISODE_GET_READING_STARTED",
	EpisodeGetReadingSuccess: "EPISODE_GET_READING_COMPLETED",
	EpisodeGetReadingFailure: "EPISODE_GET_READING_FAILED",

	EpisodeGetReadingIdRequest: "EPISODE_GET_READINGID_STARTED",
	EpisodeGetReadingIdSuccess: "EPISODE_GET_READINGID_COMPLETED",
	EpisodeGetReadingIdFailure: "EPISODE_GET_READINGID_FAILED",

	EpisodeGetUserCountRequest: "EPISODE_GET_USER_COUNT_STARTED",
	EpisodeGetUserCountSuccess: "EPISODE_GET_USER_COUNT_COMPLETED",
	EpisodeGetUserCountFailure: "EPISODE_GET_USER_COUNT_FAILED",

	EpisodeGetUserEngagementRequest: "EPISODE_GET_USER_ENGAGEMENT_STARTED",
	EpisodeGetUserEngagementSuccess: "EPISODE_GET_USER_ENGAGEMENT_COMPLETED",
	EpisodeGetUserEngagementFailure: "EPISODE_GET_USER_ENGAGEMENT_FAILED",

	EpisodeGetMinDateRequest: "EPISODE_GET_MIN_DATE_STARTED",
	EpisodeGetMinDateSuccess: "EPISODE_GET_MIN_DATE_COMPLETED",
	EpisodeGetMinDateFailure: "EPISODE_GET_MIN_DATE_FAILED",

	EpisodeValidateFeedRequest: "EPIODE_GET_VALIDATEFEED_STARTED",
	EpioseValidateFeedSuccess: "EPISODE_GET_VALIDATEFEED_COMPLETED",
	EpioseValidateFeedFailure: "EPISODE_GET_VALIDATEFEED_FAILED",

	EpisodeUserMetricRequest: "EPISODE_USER_METRIC_STARTED",
	EpisodeUserMetricSuccess: "EPISODE_USER_METRIC_COMPLETED",
	EpisodeUserMetricFailure: "EPISODE_USER_METRIC_FAILED",

	EpisodeUpdateEngagementRequest: "EPISODE_UPDATE_ENGAGEMENT_STARTED",
	EpisodeUpdateEngagementSuccess: "EPISODE_UPDATE_ENGAGEMENT_COMPLETED",
	EpisodeUpdateEngagementFailure: "EPISODE_UPDATE_ENGAGEMENT_FAILED"
}